
import { View } from 'backbone';
import eventBus         from 'EventBus.js';
import listService from 'ListService';
import util from 'util/Util.js';
import nameTemplate from 'report/properties/main/chart-fields.ejs';
import MainFormulaModal from 'common-views/MainFormulaModalView.js';
import ReportFormulaModal from 'common-views/ReportFilterFormulaModalView';

class MainChartFieldsView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'click #groupFormula, #valueFormula' :'updateGroupOrValue',
            'change select' : 'updateSelectAttributes'

        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        
        if (propName === 'dataGroup' || propName === 'dataValue' || propName === 'dataAggregate') {
            let colid = "0";

            if (propName === 'dataValue' || propName === 'dataAggregate') {
                colid = "1";
            }

            if (propName === 'dataAggregate') {
                this.updateColumnProperty(colid, 'aggregation', propVal);
                this.updateReportingMetaDataColumn(colid, 'aggregation', propVal);
            } else {
                const dataType = $(ev.currentTarget).find(':selected').first().attr('dataType');
                this.updateColumnProperty(colid, 'fieldId', listService.getCleanedId(propVal));
                this.updateColumnProperty(colid, 'fieldDataType', dataType);
                this.updateReportingMetaDataColumnField(colid, listService.getCleanedId(propVal), dataType);
            }
        }

        this.model.set( propName, propVal, {silent:true} );
    }

    updateGroupOrValue(ev){
        this.model.set('formulaType', ev.target.name, {silent:true});
        this.model.set('type', 'DataSource', {silent:true});
        this.model.set('title', 'Column Formula', {silent:true});
        var formulaModal = new ReportFormulaModal({model:this.model});
        formulaModal.render().then((data)=>{
            if (ev.target.name === 'groupFormula'){
                this.updateColumnProperty('0', 'fieldId', 'Formula');
                this.updateColumnProperty('0', 'fieldDataType', 'NVARCHAR(400)');
                this.updateColumnProperty('0', 'usesExpression', 'true');
                this.updateReportingMetaDataColumnField('0', 'Formula', 'NVARCHAR(400)', data); 
                this.updateColumnExpression('0');
                this.model.set( 'dataGroup', 'Formula', {silent:true} );
            }else if (ev.target.name === 'valueFormula'){
                this.updateColumnProperty('1', 'fieldId', 'Formula');
                this.updateColumnProperty('1', 'fieldDataType', 'NVARCHAR(400)');
                this.updateColumnProperty('1', 'usesExpression', 'true');
                this.updateReportingMetaDataColumnField('1', 'Formula', 'NVARCHAR(400)', data); 
                this.updateColumnExpression('1');
                this.model.set( 'dataValue', 'Formula', {silent:true} );
            }
            this.model.set(ev.target.name,data, {silent:false});
            this.render();
        }).catch(e => {
            console.log(e);
        });
        
    }

    // Only want to list Fields marked as InUse (Configured in the DataSource)
    loadFieldsFromDatasource( dsId ) {
        const ds = listService.getDataSources(listService.cleanId(dsId));

        if (ds && ds.Fields && ds.Fields.Field) {

            const fieldGroupEl = $('#dataGroup');
            const fieldValueEl = $('#dataValue');
            _.forEach(ds.Fields.Field, (field) => {
                if (util.isTrue(field.inUse)) {
                    let fname = '';

                    switch (field.id) {
                        case 'CreateDate':
                            fname = 'Meta - Last Submission Date';
                            break;
                        case 'E':
                            fname = 'Meta - Instance Number';
                            break;
                        case 'FormInstanceGUID':
                            fname = 'Meta - Instance ID';
                            break;
                        case 'FormInstanceId':
                            fname = 'Meta - Link';
                            break;
                        case 'MajorVersion':
                            fname = 'Meta - Version Major';
                            break;
                        case 'MinorVersion':
                            fname = 'Meta - Version Minor';
                            break;
                        case 'Name':
                            fname = 'Meta - Instance Name';
                            break;
                        case 'ParentGUID':
                            fname = 'Meta - Parent Instance ID';
                            break;
                        case 'StageName':
                            fname = 'Meta - Stage';
                            break;

                        default:
                            fname = field.name.replace('|',' - ');
                            break;
                    }

                    const elOpt = new Option((field.displayName.trim() || fname), field.id);
                    fieldGroupEl[0].options[fieldGroupEl[0].options.length] = elOpt;
                    elOpt.setAttribute("dataType", field.dataType);

                    const elOpt2 = new Option((field.displayName.trim() || fname), field.id);
                    fieldValueEl[0].options[fieldValueEl[0].options.length] = elOpt2;
                    elOpt2.setAttribute("dataType", field.dataType);
                }
            })


            $('#dataGroup').append('<optgroup label="──────────"></optgroup>');
            $('#dataGroup').append('<option value="Formula" datatype="NVARCHAR(400)">Formula</option>');
            $('#dataValue').append('<optgroup label="──────────"></optgroup>');
            $('#dataValue').append('<option value="Formula" datatype="NVARCHAR(400)">Formula</option>');


        }
    }

    updateColumnProperty(rowid, propName, propVal) {
        const columns = this.model.get('Columns');

        columns.Column[rowid].Properties[propName] = propVal;
    }

    updateColumnExpression(rowid) {
        const groupFormula = this.model.get('groupFormula');
        const valueFormula = this.model.get('valueFormula');
        const columns = this.model.get('Columns');

        if (groupFormula && rowid === '0'){
            if (!columns.Column[rowid].EXPR){
                columns.Column[rowid].EXPR = {};
                columns.Column[rowid].EXPR.id = groupFormula.id;
                columns.Column[rowid].EXPR.type = groupFormula.type;
                columns.Column[rowid].EXPR.arguments = groupFormula.arguments;                
            }else{
                columns.Column[rowid].EXPR.id = groupFormula.id;
                columns.Column[rowid].EXPR.type = groupFormula.type;
                columns.Column[rowid].EXPR.arguments = groupFormula.arguments;
            }
        }

        if (valueFormula && rowid === '1'){
            if (!columns.Column[rowid].EXPR){
                columns.Column[rowid].EXPR = {};
                columns.Column[rowid].EXPR.id = valueFormula.id;
                columns.Column[rowid].EXPR.type = valueFormula.type;
                columns.Column[rowid].EXPR.arguments = valueFormula.arguments;                
            }else{
                columns.Column[rowid].EXPR.id = valueFormula.id;
                columns.Column[rowid].EXPR.type = valueFormula.type;
                columns.Column[rowid].EXPR.arguments = valueFormula.arguments;
            }
        }
      }

    // Look up Column by ID and set properties
    updateReportingMetaDataColumnField(rowid, dsFieldId, dataType, data ) {
        let md = listService.getReportingMetaData(this.model.get('id'));
        
        if(!md){
            listService.setReportingMetaData(this.model.get('dataSourceId'), this.model, true);
            md = listService.getReportingMetaData(this.model.get('id'));
        }

        const sortOn = $('#sortOrder option:selected').val();
        const sortOrderVal = $('#sortType option:selected').val();

        if (md.Columns) {
            _.forEach(md.Columns, (col) => {
                if (col.id.toString() === rowid.toString()) {
                    let aggregate = 'group';
                    let sort = 'none';
                    let sortOrder = '0';


                    if (col.id.toString() === "0") {
                        if (sortOn === 'group') {
                            sort = sortOrderVal;
                            if (sortOrderVal === 'asc') {
                                sortOrder = '1';
                            }
                            if (sortOrderVal === 'desc') {
                                sortOrder = '1';
                            }
                        }
                    }

                    if (col.id.toString() === '1') {
                        aggregate = $('#dataAggregate option:selected').val();
                        if (sortOn === 'value') {
                            sort = sortOrderVal;
                            if (sortOrderVal === 'asc') {
                                sortOrder = '1';
                            }
                            if (sortOrderVal === 'desc') {
                                sortOrder = '1';
                            }
                        }
                    }

                    col.aggregation = aggregate;
                    col.sortType = sort;
                    col.sortOrder = sortOrder;
                    if( data && data.arguments && util.isChart(this.model.get('factoryKey')) ){
                        col.Expression.id = data.id;
                        col.Expression.type = data.type;
                        col.Expression.Argument = data.arguments;
                    }else{
                        col.Expression.Argument = {type: 'reporting_datasourceField', value: dsFieldId, dataType: dataType};
                    }
                }
            });

        }

    }

    updateReportingMetaDataColumn(rowid, propName, propVal) {
        const md = listService.getReportingMetaData(this.model.get('id'));

        if (md.Columns) {
            _.forEach(md.Columns, (col) => {
                if (col.id.toString() === rowid.toString()) {
                    col[propName] = propVal;
                }
            });
        }
    }

    setFieldsFromColumns() {
        const columns = this.model.get('Columns');

        const grpColValue = columns.Column[0].Properties.fieldId;
        this.model.set('dataGroup', grpColValue, {silent:true});

        const valColValue = columns.Column[1].Properties.fieldId;
        const valColAgg = columns.Column[1].Properties.aggregation;
        this.model.set('dataValue', valColValue, {silent:true});
        this.model.set('dataAggregate', valColAgg, {silent:true});

    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.loadFieldsFromDatasource(this.model.get('dataSourceId'));

        this.setFieldsFromColumns();

        let dataValue = this.model.get('dataValue');

        if(dataValue.toLowerCase() === "formula"){
            dataValue = dataValue.charAt(0).toUpperCase() + dataValue.slice(1);
        }

        $("#dataGroup option[value='" + this.model.get('dataGroup') + "']").prop('selected', true);
        $("#dataValue option[value='" + dataValue + "']").prop('selected', true);
        $("#dataAggregate option[value='" + this.model.get('dataAggregate') + "']").prop('selected', true);

        this.delegateEvents();
        return this;
    }

}

export default MainChartFieldsView;
